import { render, staticRenderFns } from "./returnGoods.vue?vue&type=template&id=356f50e2&scoped=true&"
import script from "./returnGoods.vue?vue&type=script&lang=js&"
export * from "./returnGoods.vue?vue&type=script&lang=js&"
import style0 from "./returnGoods.vue?vue&type=style&index=0&id=356f50e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356f50e2",
  null
  
)

export default component.exports